document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-question').forEach((btn) => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);

      const answer = btn.nextElementSibling;
      const icon = btn.querySelector('.faq-icon');

      // Slide answer
      answer.classList.toggle('open', !expanded);

      // Only add fade-out immediately
      if (!icon.classList.contains('fade-out')) {
        icon.classList.add('fade-out');
        const newSrc = expanded
            ? icon.dataset.iconPlus
            : icon.dataset.iconMinus;
          icon.setAttribute('src', newSrc);
      } else {
        // Wait 350ms, then change icon and remove fade-out
        setTimeout(() => {
          const newSrc = expanded
            ? icon.dataset.iconPlus
            : icon.dataset.iconMinus;
          icon.setAttribute('src', newSrc);
          icon.classList.remove('fade-out');
        }, 350);
      }
    });
  });
});
